package io.horion.cv.components

import androidx.compose.runtime.*
    import com.varabyte.kobweb.compose.css.*
    import com.varabyte.kobweb.compose.foundation.layout.*
    import com.varabyte.kobweb.compose.ui.*
    import com.varabyte.kobweb.compose.ui.Modifier
    import com.varabyte.kobweb.compose.ui.modifiers.*
    import com.varabyte.kobweb.compose.ui.styleModifier
    import com.varabyte.kobweb.core.rememberPageContext
    import com.varabyte.kobweb.silk.components.graphics.Image
    import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
    import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
    import com.varabyte.kobweb.silk.components.icons.fa.IconSize
    import com.varabyte.kobweb.silk.components.navigation.Link
    import com.varabyte.kobweb.silk.components.text.SpanText
    import com.varabyte.kobweb.silk.style.toModifier
    import io.horion.cv.api.datasource.motivation.ModelLetter
    import io.horion.cv.di.koinGet
    import io.horion.cv.models.CoverLetterData
    import io.horion.cv.styles.ChevronButtonIconStyle
    import io.horion.cv.styles.ChevronButtonStyle
    import io.horion.cv.styles.CoverLetterCardButtonStyle
    import io.horion.cv.styles.CoverLetterCardStyle
    import io.horion.cv.styles.CoverLetterStyle
    import io.horion.cv.styles.LettreCarouselContainerStyle
    import io.horion.cv.styles.LettreCarouselTrackStyle
    import io.horion.cv.styles.LettreCarouselViewportStyle
    import io.horion.cv.utils.Colors
    import io.horion.cv.utils.Constants.UBUNTU
//    import io.horion.cv.utils.isDarkTheme
    import io.horion.cv.viewModel.LetterViewModel
    import org.jetbrains.compose.web.css.*

@Composable
fun LetterCarousel(isDark: Boolean) {
    val letters = CoverLetterData.letters
    val total = letters.size
    var page by remember { mutableStateOf(0) }

    Box(
        modifier = LettreCarouselContainerStyle.toModifier()
            .fillMaxWidth()
            .padding(10.px)
            .position(Position.Relative),
        contentAlignment = Alignment.Center
    ) {

        if (page > 0) {
            ChevronButtons(isDark,true) { page-- }
        }

        Box(
            modifier = LettreCarouselViewportStyle.toModifier()
                .overflow(Overflow.Hidden)
        ) {
            Row(
                modifier = LettreCarouselTrackStyle.toModifier()
                    .styleModifier {
                        property(
                            "transform",
                            "translateX(calc(-${page} * (var(--card-width) + var(--card-gap))))"
                        )
                        property("transition", "transform 0.4s ease")
                    }
            ) {
                letters.forEach {
                    CoverLetterCard(
                        letter = it,
                        isDark = isDark
                    )
                }
            }
        }
        if (page < total - 1) {
            ChevronButtons(isDark,false) { page++ }
        }
    }
}

@Composable
fun CoverLetterCard(
    isDark: Boolean,
    letter: Map.Entry<String, String>,
    modifier: Modifier = Modifier
) {
    val letterViewModel = koinGet<LetterViewModel>()
    val ctx = rememberPageContext()

    Box(
        modifier = CoverLetterCardStyle.toModifier().then(modifier)
            .cursor(Cursor.Pointer)
            .overflow(Overflow.Visible)
            .onClick {
                ModelLetter.entries
                    .firstOrNull { it.name == letter.key }
                    ?.let { letterViewModel.updateModel(it) }

                ctx.router.navigateTo("/info_letter_page?model=${letter.key}")
            },
        contentAlignment = Alignment.Center
    ) {

        Image(
            src = "/" + letter.value,
            description = "lettre de motivation",
            modifier = CoverLetterStyle
                .toModifier()
                .fillMaxSize()
                .objectFit(ObjectFit.Contain)
                .border(0.px, LineStyle.Solid, Colors.GrayLight)
                .styleModifier {
                    // ✅ légère teinte sombre sur les images en dark mode
//                        property("filter", if (isDark) "brightness(0.85)" else "none") //pour rendre limage legerement flou en dark theme
                    property("transition", "filter 300ms ease")
                }
        )

        Link(
            path = "/info_letter_page?model=${letter.key}",
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
        ) {
            Box(
                modifier = CoverLetterCardButtonStyle.toModifier()
                    .classNames("cover-letter-btn")
                    .backgroundColor(Colors.Blue)
                    .borderRadius(10.px),
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    "Utiliser ce modèle",
                    modifier = Modifier
                        .color(Colors.White)
                        .fontSize(16.px)
                        .fontFamily(UBUNTU)
                        .fontWeight(FontWeight.Medium)
                )
            }
        }
    }
}

@Composable
fun ChevronButtons(
    isDark: Boolean,
    left: Boolean,
    onClick: () -> Unit
) {
    val iconFilter = "invert(1)"

    Box(
        modifier = ChevronButtonStyle.toModifier()
            .borderRadius(28.px)
            .backgroundColor(Colors.Black.copy(alpha = 50))
            .cursor(Cursor.Pointer)
            .position(Position.Absolute)
            .top(50.percent)
            .zIndex(10)
            .styleModifier {
                property("transform", "translateY(-50%)")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
            .let {
                if (left)
                    it.left(40.px)
                else
                    it.right(40.px)
            }
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {
        if (left) {

            FaChevronLeft(
                modifier = ChevronButtonIconStyle
                    .toModifier()
                    .styleModifier { property("filter", iconFilter)},
                size = IconSize.SM
            )

        } else {
            FaChevronRight(
                modifier = ChevronButtonIconStyle
                    .toModifier()
                    .styleModifier { property("filter", iconFilter)},
                size = IconSize.SM
            )
        }
    }
}